import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import { Component } from "@/decorators";
import TipoLogEntidade from "@/models/enum/tipoLogEntidade";
import PaginationModel from "@/models/paginationModel";
import ConfiguracaoEtapaPCPModel from "@/models/pcp/configuracaoEtapaPCPModel";
import EtapaPCPModel from "@/models/pcp/etapaPCPModel";
import ConfiguracaoEtapaPCPService from "@/services/configuracaoEtapaPCPService";
import EtapaPCPService from "@/services/etapaPCPService";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        comboComponent,
        fieldsetComponent,
        logEntidadeComponent,
    },
})
export default class ConfiguracaoEtapaPCP extends EditComponentBase<ConfiguracaoEtapaPCPModel> {
    etapasOptions: Array<Object> = [];
    private configuracaoEtapaPCPService = new ConfiguracaoEtapaPCPService();

    get tipoLogEntidade(): number {
        return TipoLogEntidade.ConfiguracaoPCP;
    }

    private async loadOptions() {
        try {
            const data = await new EtapaPCPService()
                .combo()
                .withLoading()
                .resolveWithJSON<PaginationModel<EtapaPCPModel>>();

            this.etapasOptions = data.list.map(item => ({
                value: item.id,
                text: item.descricao,
            }));
        } catch {}
    }

    private async beforeMount() {
        await this.setProps(
            this.configuracaoEtapaPCPService,
            "configuracao_etapa_pcp",
            new ConfiguracaoEtapaPCPModel(),
        );

        await this.loadOptions();

        await this.load();
    }

    public async load(): Promise<void> {
        try {
            const data = await this.configuracaoEtapaPCPService
                .getByFranquia()
                .withLoading()
                .resolveWithJSON<ConfiguracaoEtapaPCPModel>();

            this.model.updateFrom(data);
        } catch {}
    }
}
